<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <path
      d="M12.3527 0.676C13.2638 -0.225334 14.7435 -0.225334 15.6546 0.676L27.3167 12.2131C28.2278 13.1144 28.2278 14.5782 27.3167 15.4795C26.4056 16.3808 24.9259 16.3808 24.0148 15.4795L14 5.572L3.98516 15.4723C3.07406 16.3736 1.59443 16.3736 0.683327 15.4723C-0.227775 14.571 -0.227775 13.1072 0.683327 12.2059L12.3454 0.6688L12.3527 0.676ZM0.6906 26.0576L12.3527 14.5205C13.2638 13.6192 14.7435 13.6192 15.6546 14.5205L27.3167 26.0576C28.2278 26.9589 28.2278 28.4227 27.3167 29.324C26.4056 30.2253 24.9259 30.2253 24.0148 29.324L14 19.4165L3.98516 29.3168C3.07406 30.2181 1.59443 30.2181 0.683327 29.3168C-0.227775 28.4155 -0.227775 26.9517 0.683327 26.0504L0.6906 26.0576Z"
      fill="currentColor"
    />
  </svg>
</template>
